import React from 'react'
import './SelfDeclaration.css';
import SelfDeclarationFile1 from "../../asset/SelfDeclaration1.pdf";
import SelfDeclarationFile2 from "../../asset/SelfDeclaration2.pdf";
import SelfDeclarationFile3 from "../../asset/Self-declaration form_PP_no_substances_ENG.pdf";

import SelfDeclarationFile1DE from "../../asset/Self-declaration form_MSS_de.pdf";
import SelfDeclarationFile2DE from "../../asset/Self-declaration form_PP_de.pdf";
import SelfDeclarationFile3DE from "../../asset/Self-declaration form_PP_no_substances_DE.pdf";

import SelfDeclarationFile1ITA from "../../asset/Self-declaration form_MSS_IT.pdf";
import SelfDeclarationFile2ITA from "../../asset/Self-declaration form_PP_IT.pdf";
import SelfDeclarationFile3ITA from "../../asset/Self-declaration form_PP_no_substances_ITA.pdf";

import SelfDeclarationFile1CZ from "../../asset/Self-declaration form_MSS_CZ.pdf";
import SelfDeclarationFile2CZ from "../../asset/Self-declaration form_PP_CZ.pdf";
import SelfDeclarationFile3CZ from "../../asset/Self-declaration form_PP_no_substances_CZ.pdf";

import DE from "../../asset/de.jpg";
import ENG from "../../asset/en.jpg";
import ITA from "../../asset/it.jpg";
import CZ from "../../asset/zc.png";

function SelfDeclaration() {
    return (
        <div>
        
            <div><img className="mt-3" style={{ height: "25px", cursor: "pointer" }} src={ENG} alt="ENG"></img></div>
            <div className="m-3">
                <h4>Minimum Social Safeguards</h4>
                <div>To Download the Self Declaration for Minimum Social Safeguards Click the Downloadlink: <a href={SelfDeclarationFile1} download>Minimum Social Safeguards</a></div>
            </div>
            <div  className="m-3">
                <h4>Pollution Prevention and Control</h4>
                <div>Please click here to download the Self Declaration form in case <b>substances of concern</b> are used: <a href={SelfDeclarationFile2} download>Substances Used</a></div>
                <div>Please click here to download the Self Declaration form in case <b>no relevant substances</b> are used: <a href={SelfDeclarationFile3} download>No Substances used</a></div>
            </div>
        <hr></hr>
            <div><img className="mt-3"  style={{ height: "25px", cursor: "pointer" }} src={DE} alt="DE"></img></div>
                <div className="m-3">
                <h4>Soziale Mindeststandards (Minimum Social Safeguards)</h4>
                <div>Klicken Sie hier, um die Selbsterklärung für die sozialen Mindeststandards herunterzuladen: <a href={SelfDeclarationFile1DE} download>Minimum Social Safeguards</a></div>
            </div>
            <div  className="m-3">
                <h4>DNSH Verminderung und Vermeidung von Umweltverschmutzung (Pollution Prevention and Control)</h4>
                <div>Klicken Sie hier, um die Selbsterklärung für die nicht wesentliche Beeinträchtigung der Vermeidung und Verminderung von Umweltverschmutzung  herunterzuladen, <b>falls potenziell schädliche Substanzen genutzt wurden</b>: <a href={SelfDeclarationFile2DE} download>Substanzen verwendet</a></div>
                <div>Klicken Sie hier, um die Selbsterklärung für die nicht wesentliche Beeinträchtigung der Vermeidung und Verminderung von Umweltverschmutzung  herunterzuladen, <b>falls keine potenziell schädliche Substanzen genutzt wurden</b>: <a href={SelfDeclarationFile3DE} download>Keine Substanzen verwendet</a></div>
            </div>
        <hr></hr>
        <div><img className="mt-3" style={{ height: "25px", cursor: "pointer" }} src={ITA} alt="ITA"/></div>
            <div className="m-3">
              <h4>Criteri Sociali Minimi (Minimum Social Safeguards)</h4>
              <div>Clicca qui per scaricare l’autodichiarazione relativa ai criteri sociali minimi: <a href={SelfDeclarationFile1ITA} download> Minimum Social Safeguards</a> </div>
            </div>
            <div className="m-3">
              <h4>DNSH Prevenzione e Riduzione dell’Inquinamento (Pollution Prevention and Control)</h4>  
              <div>Clicca qui per scaricare l’autodichiarazione relativa alla DNSH – prevenzione e riduzione dell’inquinamento, <b>se sono state utilizzate sostanze potenzialmente pericolose</b>: <a href={SelfDeclarationFile2ITA} download>Sostanza utilizzata</a></div>  
              <div>Clicca qui per scaricare l’autodichiarazione relativa alla DNSH – prevenzione e riduzione dell’inquinamento, <b>se non sono state utilizzate sostanze potenzialmente pericolose</b>: <a href={SelfDeclarationFile3ITA} download> Nessuna sostanza utilizzata</a></div>
            </div>    
        
        <hr></hr>
        <div><img className="mt-3" style={{ height: "25px", cursor: "pointer" }} src={CZ} alt="CZ"/></div>
            <div className="m-3">
              <h4>Minimální sociální záruky (Minimum Social Safeguards)</h4>
              <div>Chcete-li si stáhnout čestné prohlášení k minimálním sociálním zárukám, klikněte na odkaz ke stažení: <a href={SelfDeclarationFile1CZ} download> Minimální sociální záruky</a> </div>
            </div>
            <div className="m-3">
              <h4>Prevence a kontrola znečištění (Pollution Prevention and Control)</h4>  
              <div>V případě použití rizikových látek si prosím stáhněte tento formulář čestného prohlášení: <a href={SelfDeclarationFile2CZ} download>Použité látky</a></div>  
              <div>V případě, že žádné rizikové látky použity nebyly, stáhněte si příslušný formulář čestného prohlášení zde: <a href={SelfDeclarationFile3CZ} download> Nepoužity žádné látky</a></div>
            </div>    
        


        </div>


    )
}

export default SelfDeclaration